const env = {
	MAPBOX_API_KEY:
		"pk.eyJ1IjoiYW1hcnRoeWEwMyIsImEiOiJjbDF1ZWF1ZjYxamZ3M2JwdHRndnNtdnF3In0.oy5Fk8n13L9YO1B1aikI3g",
};

export default env;
